<div class="modal modal-account-desc">
  <div class="modal__content">
    <h1 class="h1 modal__title" translate="account-popup.title-description"></h1>

    <form (ngSubmit)="formSubmit()" [formGroup]="form" novalidate>
      <div class="form-group">
        <div class="form-field form-field--border-radius">
          @if ({ focus: false, control: form.get('comment'), field: 'comment' }; as ctx) {
            <app-form-field [isControlTouched]="ctx.control.touched"
              [errors]="ctx.control.errors"
              [errorTexts]="fieldErrors(ctx.field)"
              [submitErrors]="submitErrors.asObservable()">
              <label for="comment" [class.fade-in]="ctx.control.value || ctx.focus" translate="account-popup.field.comment"></label>
              <textarea type="text" class="form-control" id="comment" formControlName="comment" rows="3"
                autocomplete="comment" [maxLength]="maxLength"
                (focus)="ctx.focus = true"
                (blur)="ctx.focus = false"
                [placeholder]="ctx.focus ? '' : 'account-popup.field.comment' | translate">
              </textarea>
              <span class="modal-account-desc__symbols" translate="account-popup.label.symbols-left"
              [translateParams]="{count: maxLength - ctx.control.value.length}"></span>
            </app-form-field>
          }
        </div>
      </div>
      <div class="actions-wrapper actions-wrapper--popup">
        <button type="submit" class="button" translate="account-popup.button.confirm"></button>
        <button type="button" class="link button--link" [mat-dialog-close]="" translate="account-popup.button.cancel"></button>
      </div>
    </form>
  </div>
</div>
